import type { Side } from "@design-lab/shared";
import { useAtom } from "jotai";
import { useCallback } from "react";
import { artworkSelectionAtom, type MenuId } from "./state";

export function useArtworkSelection() {
  const [selectionState, setSelectionState] = useAtom(artworkSelectionAtom);

  const setSelection = useCallback(
    (side: Side, source: MenuId, id: number) => {
      setSelectionState(prev => ({
        ...prev,
        [side]: {
          activeSource: source,
          selectedId: id
        }
      }));
    },
    [setSelectionState]
  );

  const clearSelection = useCallback(
    (side: Side) => {
      setSelectionState(prev => ({
        ...prev,
        [side]: {
          activeSource: undefined,
          selectedId: undefined
        }
      }));
    },
    [setSelectionState]
  );

  const getActiveSelection = useCallback(
    (side: Side) => {
      const sideState = selectionState[side];
      return {
        activeSource: sideState.activeSource,
        selectedId: sideState.selectedId
      };
    },
    [selectionState]
  );

  return {
    selectionState,
    setSelection,
    clearSelection,
    getActiveSelection
  };
}
